<template>
  <div style="border: 1px solid #ccc;" class="myeditor">
    <Toolbar style="border-bottom: 1px solid #e7e7e7" :editor="editor" :defaultConfig="$store.state.isUpVideoShow ? toolbarConfig : toolbarConfigNoVideo" :mode="mode" />
    <Editor style="height: 500px; overflow-y: hidden;" v-model="html" :defaultConfig="editorConfig" :mode="mode"
      @onCreated="onCreated" @onChange="onChange" />

    <div class="emo_box" v-if="emoShow" @click="onClickEmoBlank($event)">
      <emjoy ref="emjoy" @pushvalue="pushvalue" @closeEmo="emoShow = false"></emjoy>
    </div>
    <div class="loading_box" v-show="loadingFlag">
      <van-loading type="spinner" color="#1989fa" />
    </div>
  </div>
</template>
    
<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { Boot } from "@wangeditor/editor";
import emjoy from "./emjoy.vue";
import get from "@/api/get";
import { Dialog, Toast } from "vant";
import lrz from "lrz";
import { $ } from "dom7";



class MyButtonMenu {
  constructor() {
    this.title = "表情包"; // 自定义菜单标题
    this.iconSvg =
      '<svg viewBox="0 0 1024 1024"><path d="M512 1024C230.4 1024 0 793.6 0 512S230.4 0 512 0s512 230.4 512 512-230.4 512-512 512z m0-102.4c226.742857 0 409.6-182.857143 409.6-409.6S738.742857 102.4 512 102.4 102.4 285.257143 102.4 512s182.857143 409.6 409.6 409.6z m-204.8-358.4h409.6c0 113.371429-91.428571 204.8-204.8 204.8s-204.8-91.428571-204.8-204.8z m0-102.4c-43.885714 0-76.8-32.914286-76.8-76.8s32.914286-76.8 76.8-76.8 76.8 32.914286 76.8 76.8-32.914286 76.8-76.8 76.8z m409.6 0c-43.885714 0-76.8-32.914286-76.8-76.8s32.914286-76.8 76.8-76.8c43.885714 0 76.8 32.914286 76.8 76.8s-32.914286 76.8-76.8 76.8z"></path></svg>'; // 可选
    this.tag = "button";
  }

  // 获取菜单执行时的 value ，用不到则返回空 字符串或 false
  getValue(editor) {
    // return ' hello '
  }
  // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
  isActive(editor) {
    return false;
  }
  // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
  isDisabled(editor) {
    return false;
  }
  // 点击菜单时触发的函数
  exec(editor, value) {
    if (this.isDisabled(editor)) return;
    // editor.insertText(value) // value 即 this.value(editor) 的返回值
    vm.emoShow = true;
  }
}
let vm = null;
const menu1Conf = {
  key: "myEmo1", // 定义 menu key ：要保证唯一、不重复（重要）
  factory() {
    return new MyButtonMenu(); // 把 `YourMenuClass` 替换为你菜单的 class
  },
};
// 注册自定义的菜单按钮
Boot.registerMenu(menu1Conf);

export default {
  name: "myEditor",
  components: { Editor, Toolbar, emjoy },
  props: {
    evalue: {
      default: ''
    }
  },
  data() {
    let _this = this
    return {
      editor: null,
      emoShow: false,
      html: "",
      toolbarConfig: {
        toolbarKeys: [
          {
            key: "group-image",
            title: "图片",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',
            menuKeys: ["insertImage", "uploadImage"],
          },
          // "emotion",
          {
            key: "group-video",
            title: "视频",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z"></path></svg>',
            menuKeys: ["insertVideo", "uploadVideo"],
          },
          
          "bold",
          "italic",
          "headerSelect",
          "insertTable",
          "color",
          "bgColor",
          "justifyLeft",
          "justifyRight",
          "justifyCenter",
          "undo",
          "redo",
          "|",
          "fullScreen"
        ],
        insertKeys: {
          index: 0,
          keys: ["myEmo1"],
        },
        modalAppendToBody: true
      },
      toolbarConfigNoVideo: {
        toolbarKeys: [
          {
            key: "group-image",
            title: "图片",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',
            menuKeys: ["insertImage", "uploadImage"],
          },
          // "emotion",
          // {
          //   key: "group-video",
          //   title: "视频",
          //   iconSvg:
          //     '<svg viewBox="0 0 1024 1024"><path d="M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z"></path></svg>',
          //   menuKeys: ["insertVideo", "uploadVideo"],
          // },
          
          "bold",
          "italic",
          "headerSelect",
          "insertTable",
          "color",
          "bgColor",
          "justifyLeft",
          "justifyRight",
          "justifyCenter",
          "undo",
          "redo",
          "|",
          "fullScreen",
        ],
        insertKeys: {
          index: 0,
          keys: ["myEmo1"],
        },
        modalAppendToBody: true
      },
      editorConfig: {
        placeholder:
          "<div style='font-style: normal;'>添加正文<br><p style='font-size: .2rem;'>小提示:可在word中编辑、排版后将文章内容粘贴(ctrl+v) 到此处</p></div>",
        maxLength: 10000,
        MENU_CONF: {
          uploadImage: {
            // server: '/api/upload',
            allowedFileTypes: ['image/*'],
            async customUpload(file) {
              _this.addImgFile(file, (url) => {
                _this.insertNode(url, 'img')
              });


            }

          },
          uploadVideo: {
            allowedFileTypes: ['video/*'],
            async customUpload(file) {
              _this.addVideoFile(file, url => {
                _this.insertNode(url, 'video')

              });


            }

          }
        },


      },
      mode: "default", // or 'simple'
      emotion: [],
      loadingFlag: false,
      Bucket: "",
      Region: "",
      allowPrefix: "",
      protocol: "https:",
      file1: "file", //input数据类型
      imgArry: {}, //当前图片对象
      videoArray: {}, // 当前的视频对象
      uploadType: 1, // 1-图片 2-视频
    };
  },
  created() {
    vm = this
  },
  mounted() {

  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },

  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      this.html = this.evalue
      this.editor.on('modalOrPanelShow', modalOrPanel => {
        if (modalOrPanel.type !== 'modal') return

        const { $elem } = modalOrPanel // modal element
        const width = $elem.width()
        const height = $elem.height()

        // set modal position z-index
        $elem.css({
          left: '50%',
          top: '50%',
          marginLeft: `-${width / 2}px`,
          marginTop: `-${height / 2}px`,
          zIndex: 1000
        })

        let bableDom =  $('.babel-container')
        for(let i = 0; i < bableDom.length; i++) {
          if (bableDom[i].innerText === '图片描述' || bableDom[i].innerText === '视频封面') {
            bableDom[i].style.display = 'none'
          }
          if (bableDom[i].innerText === '视频地址') {
            bableDom[i].children[1].placeholder = "输入嵌入代码或第三方<iframe >"
          }
        }
        // $('.babel-container')




        // show mask div
        // document.getElementById('mask').style.display = 'block'
      })
    },
    // wangEditor 内容变化回调
    onChange(editor) {
      this.transVideo()
      // console.log(this.editor.getElemsByType('video'), 666)
    },
    transVideo(){
      let _this = this
      // console.log('调用了吗')
      if (this.$store.state.isInGame && this.$store.state.isU3d) {
        let videos = document.querySelectorAll('video')
        for(let i = 0; i < videos.length; i++ ) {
          videos[i].poster = require('../../../assets/img/rich/cover.jpg')
          videos[i].addEventListener('click', function (e) {
            console.log('点击了视频', e.target.currentSrc)
            _this.goUrl(e.target.currentSrc)
          })
        }
        // $('iframe').click(function (e) {
        //   console.log(e, 'iframe的event')
        //   console.log('点击了iframe')
        // })
      } else {
        // $("video").bind('contextmenu', function () { return false; })
      }
    },
    goUrl(url){
      var count = 3000;
      var pace = 50;
      let isQa = /^(test|qa)-/.test(location.hostname);
      let pageUrl = 'https://' + (isQa ? 'qa-' : '') + 'www.sugarfungame.com/actv/communityVideo/index.html?id='
      setTimeout(function(){
          try {
              window.gotoUrl(pageUrl + url);
          } catch (err) {
              count = count - pace;
              if (count >= 0) {
                  arguments.callee();
              }
          }
      }, pace);
    },
    onClickEmoBlank(e) {
      if (e.target.className === "emo_box") {
        this.emoShow = false
      }
    },

    insertNode(src, type) {
      if (type === 'img') {
        const node = {
          type: "image",
          src: src,
          children: [{ text: "" }],
        };
        this.editor.insertNode(node);
      } else if (type === 'emo') {
        const node = {
          type: "image",
          src: src,
          style: { width: '1.5rem', height: '1.5rem' },
          children: [{ text: "" }],
        };
        this.editor.insertNode(node);
      } else if (type === 'video') {
        const node = {
          type: 'video',
          src,
          poster: '',
          // width: '',// 可以指定视频的默认宽高
          // height: '',
          children: [{ text: "" }],
        };
        this.editor.insertNode(node);
      }
     
    },
    pushvalue(item) {
      // this.insertNode(item)
      this.insertNode(item.gifSrc, 'emo')
      this.emoShow = false
    },
    deleteClick() { },


    //视频上传
    addVideoFile(file, insertNode) {
      if (this.editor.getElemsByType('video').length >= 10) {
        Toast('上传视频个数已达上限')
        return
      }
      this.uploadType = 2
      let _this = this;
      var indexNum = file.name.lastIndexOf(".");
      var lastName = file.name.substr(indexNum + 1);
      var nameArr = ["mp4", 'MP4', 'MOV', 'mov'];
      console.log(lastName,'lastName')
      console.log(file, 'file')
      var imgFlag = false;
      for (var i = 0; i < nameArr.length; i++) {
        if (lastName == nameArr[i]) {
          imgFlag = true;
        }
      }
      setTimeout(function () {
        if (imgFlag) {
          if ((file.size / (1024 * 1024)).toFixed(3) <= 2*1024) {
            //小于2G
            file.newName =
              // $(".userInfo").val() +
              "_" + +new Date() + "." + lastName;
            try {
              file &&
                _this.uploadFile(
                  file,
                  // 上传成功的回调
                  function (err, data) {
                    if (data) {
                      if (location.host.includes('zlongame')) {
                          _this.videoArray.detail = data.url.replace(
                            "snspic-1251257918.cos.ap-shanghai.myqcloud.com",
                            "snspic.zlongame.com"
                          );
                        } else if (location.host.includes('sugarfungame')) {
                          _this.videoArray.detail = data.url.replace(
                            "snspic-1251257918.cos.ap-shanghai.myqcloud.com",
                            "snspic.sugarfungame.com"
                          );
                        }
                        _this.videoArray.path = _this.videoArray.detail
                        _this.loadingFlag = false;
                        insertNode(_this.videoArray.path)
                    } else {
                      Dialog.alert({
                        message: err,
                      });
                    }
                  }
                );
            } catch (err) {
              Dialog.alert({
                message: err,
              });
            }
          } else {
            Dialog.alert({
              message: "视频太大啦！请选择2G以内的视频上传",
            });
            _this.file1 = "text";
            setTimeout(function () {
              _this.file1 = "file";
            }, 30);
          }
        } else {
          Dialog.alert({
            message: "不支持该视频格式，请选择MP4、MOV形式上传",
          });
        }
      }, 600);
    },
    //图片上传
    addImgFile(file, insertNode) {
      this.uploadType = 1
      let _this = this;
      var indexNum = file.name.lastIndexOf(".");
      var lastName = file.name.substr(indexNum + 1);
      console.log(lastName, '后缀名')
      var nameArr = ["gif", "jpg", "jpeg", "png", "GIF", "JPG", "PNG"];
      var imgFlag = false;
      for (var i = 0; i < nameArr.length; i++) {
        if (lastName == nameArr[i]) {
          imgFlag = true;
        }
      }
      setTimeout(function () {
        if (imgFlag) {
          if ((file.size / (1024 * 1024)).toFixed(3) <= 15) {
            //小于5M
            file.newName =
              // $(".userInfo").val() +
              "_" + +new Date() + "." + lastName;
            try {
              lrz(file, { width: 1024 })
                .always(function () {
                  // return;
                  file &&
                    _this.uploadFile(
                      file,
                      // 上传成功的回调
                      function (err, data) {
                        if (data) {

                          if (location.host.includes('zlongame')) {
                          _this.imgArry.detail = data.url.replace(
                            "snspic-1251257918.cos.ap-shanghai.myqcloud.com",
                            "snspic.zlongame.com/pressure"
                          );
                        } else if (location.host.includes('sugarfungame')) {
                          _this.imgArry.detail = data.url.replace(
                            "snspic-1251257918.cos.ap-shanghai.myqcloud.com",
                            "snspic.sugarfungame.com/pressure"
                          );
                        }
                        
                          _this.imgArry.mindetail = `${_this.imgArry.detail}${_this.$store.state.imgThumb}`;
                          _this.imgArry.path = `${_this.imgArry.detail}`;
                          _this.loadingFlag = false;
                          insertNode(_this.imgArry.path)
                        } else {
                          Dialog.alert({
                            message: err,
                          });
                        }
                      }
                    );
                });
            } catch (err) {
              Dialog.alert({
                message: err,
              });
            }
          } else {
            Dialog.alert({
              message: "图片太大啦！请选择15M以内的图片上传",
            });
            _this.file1 = "text";
            setTimeout(function () {
              _this.file1 = "file";
            }, 30);
          }
        } else {
          Dialog.alert({
            message: "不支持该图片格式",
          });
        }
      }, 600);
    },
    // 计算签名
    getAuthorization(options, callback) {
      get.getCosTemToken().then((res) => {
        var data;
        try {
          data = new Function("return " + JSON.stringify(res.data.data))();
          this.allowPrefix = data.allowPrefix;
          this.Region = data.region;
          this.Bucket = data.bucketName;
        } catch (res) {
          console.log(res)
        }
        if (data) {
          callback(null, {
            XCosSecurityToken: data.credentials.sessionToken,
            // eslint-disable-next-line no-undef
            Authorization: CosAuth({
              SecretId: data.credentials.tmpSecretId,
              SecretKey: data.credentials.tmpSecretKey,
              Method: options.Method,
              Pathname: options.Pathname,
            }),
          });
        } else {
          callback("获取签名出错");
          this.loadingFlag = false;
        }
      });
    },
    uploadFile(file, callback, obj) {
      // 蒙层
      this.loadingFlag = true;
      var self = this;
      var Key =
        // self.allowPrefix +
        new Date().getFullYear() +
        "/" +
        (new Date().getMonth() + 1) +
        "/" +
        file.newName; // 这里指定上传目录和文件名
      self.getAuthorization(
        { Method: "PUT", Pathname: "/" + Key },
        function (err, info) {
          if (err) {
            alert(err);
            return;
          }
          let prefix =
            self.protocol +
            "//" +
            self.Bucket +
            ".cos." +
            self.Region +
            ".myqcloud.com/";
          var auth = info.Authorization;
          var XCosSecurityToken = info.XCosSecurityToken;
          var url =
            prefix +
            self.allowPrefix +
            self.camSafeUrlEncode(Key).replace(/%2F/g, "/");
          var xhr = new XMLHttpRequest();
          xhr.open("PUT", url, true);
          xhr.setRequestHeader("Authorization", auth);
          if (self.uploadType === 1) {
            xhr.setRequestHeader(
              "Pic-Operations",
              JSON.stringify({
                is_pic_info: 1,
                rules: [
                  {
                    fileid: "/pressure/" + Key,
                    rule: "imageMogr2/format/webp",
                  },
                ],
              })
            );
          }

          XCosSecurityToken &&
            xhr.setRequestHeader("x-cos-security-token", XCosSecurityToken);
          // xhr.upload.onprogress = function (e) {
          //   // if (obj) {
          //   // }
          // };
          xhr.onload = function () {
            if (xhr.status === 200 || xhr.status === 206) {
              var ETag = xhr.getResponseHeader("etag");
              callback(null, { url: url, ETag: ETag });
            } else {
              callback("上传失败，状态码：" + xhr.status);
            }
          };
          xhr.onerror = function () {
            callback("上传失败，请检查是否配置跨域规则");
          };
          xhr.send(file);
        }
      );
    },
    camSafeUrlEncode(str) {
      return encodeURIComponent(str)
        .replace(/!/g, "%21")
        .replace(/'/g, "%27")
        .replace(/\(/g, "%28")
        .replace(/\)/g, "%29")
        .replace(/\*/g, "%2A");
    },


    // 图片上传结束
  },


};
</script>
    
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss">
.myeditor {

  // width: 100%;
  &.w-e-toolbar {
    background-color: #fcfcfc;
  }

  &.w-e-full-screen-container {
    z-index: 100;
  }

  border-color:#e7e7e7 !important;
  border-top: 0;

}

.w-e-modal {
  &>div .babel-container:nth-child(3) {
    display: none;
  }
}

.emo_box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba($color: #000000, $alpha: 0.6);
}
</style>
    